<template>
	<component
		:is="tag"
		class="portal-status-pill"
		:style="{
			'--status-background': background,
			'--status-color': color,
		}"
	>
		<slot></slot>
	</component>
</template>

<script>
	export default {
		name: 'PortalStatusPill',

		props: {
			background: { type: String, required: false, default: 'var(--v-gray_20-base)' },
			color: { type: String, required: false, default: 'var(--portal-muted)' },
			tag: { type: String, required: false, default: 'span' },
		},
	};
</script>

<style scoped lang="scss">
	.portal-status-pill {
		width: fit-content;
		min-height: 26px;
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 4px 9px;
		border-radius: 999px;
		background: var(--status-background);
		color: var(--status-color);
		font-size: 12px;
		font-weight: 650;
		line-height: 1.25;
		white-space: nowrap;
	}
</style>
